// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"524":"d37a3571","900":"0ce33051"}[chunkId] + ".css";
};